export default __webpack_public_path__ + "static/media/logo-aden-faculty.0202e2a1.png";